import { LoggingService } from 'src/app/core/services/logging.service';
import { ToasterNotificationService } from './../../../../shared/components/toaster-notification/toaster-notification.service';
import {
  Component,
  OnInit
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreService } from 'src/app/core/services/core.service';
import {
  ERROR_OCCURED_TRY_AGAIN_LATER,
  FILL_ALL_MANDATORY_FIELDS,
  PROCEED_CHANGES,
  UPDATE_INACTIVE_USER,
  USER_DETAILS_NOT_UPDATED,
  USER_DETAILS_UPDATED
} from '../../../../shared/constants/messages';
import {
  DASHBOARD_URL, DROPDOWN_ACCESS_LEVEL, DROPDOWN_FLUENCY, DROPDOWN_GENDER, DROPDOWN_LANGUAGE,
  DROPDOWN_ROLETYPE,
  DROPDOWN_USERTYPE,
  MANAGE_WORKFLOWS_URL, NEW_USER_URL, NOTIFICATION_ERROR, NOTIFICATION_SUCCESS,
  NOTIFICATION_WARNING
} from './../../../../shared/constants/constant';
import { Dropdown } from './../../../../shared/models/dropdown.model';
import { NotificationAlert } from './../../../../shared/models/notificationAlert.model';
import {
  UserDetails
} from './../../../../shared/models/userDetail.model';
import { ManageUsersService } from './../../services/manage-users.service';

@Component({
  selector: 'app-create-update-profile',
  templateUrl: './create-update-profile.component.html',
  styleUrls: ['./create-update-profile.component.scss'],
})
export class CreateUpdateProfileComponent implements OnInit {
  public profileForm: FormGroup;
  public submittedProfileForm = false;
  public profileFormSaving = false;
  public languageOptions: Dropdown[];
  public languageFluencyOptions: Dropdown[];
  public roleTypeOptions: Dropdown[];
  public accessLevelOptions: Dropdown[];
  public userTypeOptions: Dropdown[];
  public genderCodeOptions: Dropdown[];
  public alert: NotificationAlert;
  public showInactiveUserPopup = false;
  public selectedStatus: string;
  public popupMessage: string;
  public formEdit = false;
  public isEditableProfile = true;
  public usersList: UserDetails[];
  public selectedReportingManager: number;
  public showUnSavedChangesPopup = false;
  public showBackCPQPNavigationButton = false;

  private selectedUser: UserDetails;

  constructor(
    private manageUsersService: ManageUsersService,
    public coreService: CoreService,
    private router: Router,
    private route: ActivatedRoute,
    private loggingService: LoggingService,
    private toasterNotificationService: ToasterNotificationService
  ) {

  }
  /**
   *
   *
   * @memberof CreateUpdateProfileComponent
   * @description function execute once component start render on UI
   */
  ngOnInit(): void {
    try {
      this.languageOptions = this.coreService.getDropdownValuesByID(
        DROPDOWN_LANGUAGE
      );
      this.languageFluencyOptions = this.coreService.getDropdownValuesByID(
        DROPDOWN_FLUENCY
      );
      this.userTypeOptions = this.coreService.getDropdownValuesByID(
        DROPDOWN_USERTYPE
      );
      this.genderCodeOptions = this.coreService.getDropdownValuesByID(
        DROPDOWN_GENDER
      );
      this.roleTypeOptions = this.coreService.getDropdownValuesByID(
        DROPDOWN_ROLETYPE
      );
      this.accessLevelOptions = this.coreService.getDropdownValuesByID(DROPDOWN_ACCESS_LEVEL);
      this.usersList = this.manageUsersService.getAllExistingUsers();
      if (!this.usersList) {
        const users: UserDetails[] = JSON.parse(sessionStorage.getItem('ALL_USERS'));
        this.usersList = users;
      }
      if (this.route && this.route.parent) {
        this.route.parent.params.subscribe(params => {
          const id = new Number(params.id).valueOf();
          if (params.id === NEW_USER_URL) {
            if (history && history.state && (history.state.id || history.state.guid)) {
              this.selectedUser = history.state;
              this.resetUserProfile();
            } else {
              this.router.navigateByUrl('/manage-users');
            }
          } else {
            this.getUserDetails(id);
          }
        });
      }
      if (this.router.url.includes(MANAGE_WORKFLOWS_URL)) {
        this.showBackCPQPNavigationButton = true;
      }
      if (this.router.url.includes(DASHBOARD_URL)) {
        this.isEditableProfile = false;
      }
    } catch (exp) {
      this.loggingService.logTrace('create-update-profile.component -> ngOnInit' + exp);
    }
  }
  /**
   *
   *
   * @memberof CreateUpdateProfileComponent
   * @description used to save user data in DB
   */
  public saveUser(): void {
    try {
      this.submittedProfileForm = true;
      this.profileFormSaving = true;
      if (this.profileForm.valid) {
        this.submittedProfileForm = false;
        const userDetails = this.profileForm.getRawValue();
        const data = {
          loginID: this.selectedUser.loginID ? this.selectedUser.loginID : null,
          guid: userDetails.guid,
          loginName: userDetails.loginName,
          firstName: userDetails.firstName,
          middleName: userDetails.middleName,
          lastName: userDetails.lastName,
          preferredName: userDetails.preferredName,
          notificationEmailID: userDetails.notificationEmailID,
          adEmailID: userDetails.adEmailID,
          currentPosition: userDetails.currentPosition,
          nodeID: userDetails.nodeID ? userDetails.nodeID : 1,
          roleTypeCode: userDetails.roleTypeCode,
          preDominantRoleTypeCode: userDetails.preDominantRoleTypeCode,
          company: userDetails.userTypeCode,
          officeLocation: userDetails.officeLocation,
          firstLangCode: userDetails.firstLangCode,
          firstLangFluencyCode: userDetails.firstLangFluencyCode,
          secondLangCode: userDetails.secondLangCode,
          secondLangFluencyCode: userDetails.secondLangFluencyCode,
          genderCode: userDetails.genderCode,
          totalExperience: 0,
          relevantExperience: 0,
          workPhoneNumber: userDetails.workPhoneNumber,
          mobileNumber: userDetails.mobileNumber,
          notes: userDetails.notes,
          isActive: userDetails.isActive === 'Yes' ? '1' : '0',
          isReturningCP: userDetails.isReturningCP === 'Yes' ? '1' : '0',
          userTypeCode: userDetails.userTypeCode,
          managerLoginID: this.selectedReportingManager,
          accessTypeCode: userDetails.accessTypeCode,
        };

        if (this.campareData(data)) {
          this.alert = {
            type: NOTIFICATION_WARNING,
            message: 'No changes on this page.',
          };
          this.profileFormSaving = false;
        } else {
          this.manageUsersService.createUser(data).subscribe(
            (response) => {
              this.alert = null;
              if (this.selectedUser && this.selectedUser.loginID) {
                this.getUserDetails(this.selectedUser.loginID);
              } else {
                this.getAllUser(data.guid);
              }
              if (response && response.value === '1001') {
                this.toasterNotificationService.showWarningNotification(UPDATE_INACTIVE_USER);
              } else {
                this.toasterNotificationService.showSuccessNotification(USER_DETAILS_UPDATED);
              }
            },
            (error) => {
              this.alert = {
                type: NOTIFICATION_ERROR,
                message: `${ERROR_OCCURED_TRY_AGAIN_LATER}`,
              };
              this.profileFormSaving = false;
            }
          );
        }
      } else {
        this.alert = {
          type: NOTIFICATION_ERROR,
          message: `${FILL_ALL_MANDATORY_FIELDS}`,
        };
        this.profileFormSaving = false;
      }
    } catch (exp) {
      this.loggingService.logTrace('create-update-profile.component -> saveUser' + exp);
    }
  }
  /**
   *
   *
   * @param {*} data
   * @return {*}  {boolean}
   * @memberof CreateUpdateProfileComponent
   * @description used to compare user data
   */
  public campareData(data): boolean {
    try {
      for (let key of Object.keys(data)) {
        if (this.selectedUser[key] !== data[key]) {
          return false;
        }
      }
      return true;
    } catch (exp) {
      this.loggingService.logTrace('create-update-profile.component -> campareData' + exp);
    }
  }
  /**
   *
   *
   * @param {*} guid
   * @memberof CreateUpdateProfileComponent
   * @description used to fetch all users from DB
   */
  public getAllUser(guid): void {
    try {
      this.manageUsersService.getAllUsers().subscribe((response) => {
        const index = response.findIndex(((x) => x.guid === guid));
        this.manageUsersService.updateTabs.next(response[index]);
        this.profileFormSaving = false;
      });
    } catch (exp) {
      this.loggingService.logTrace('create-update-profile.component -> getAllUser' + exp);
    }
  }
  /**
   *
   *
   * @param {number} loginID
   * @memberof CreateUpdateProfileComponent
   * @description used to get user details using login ID
   */
  public getUserDetails(loginID: number): void {
    try {
      if (loginID) {
        this.manageUsersService.getUser(loginID).subscribe(
          (user) => {
            if (user) {
              this.profileFormSaving = false;
              this.selectedUser = user;
              this.resetUserProfile();
              this.manageUsersService.updateTabs.next(user);
            } else {
              this.alert = {
                type: NOTIFICATION_ERROR,
                message: `${USER_DETAILS_NOT_UPDATED}`,
              };
              this.profileFormSaving = false;
            }
          },
          (error) => {
            this.alert = {
              type: NOTIFICATION_ERROR,
              message: 'No such user exist.',
            };
            this.profileFormSaving = false;
          }
        );
      }
    } catch (exp) {
      this.loggingService.logTrace('create-update-profile.component -> getUserDetails' + exp);
    }
  }
  /**
   *
   *
   * @memberof CreateUpdateProfileComponent
   * @description used to reset user form data
   */
  public resetUserProfile(): void {
    try {
      this.submittedProfileForm = false;
      this.profileFormSaving = false;
      this.formEdit = !this.coreService.isAdmin;
      this.profileForm = this.manageUsersService.getUserProfileFormControls(
        this.selectedUser
      );
      this.getReportingManagerLoginId();
      this.profileForm.controls.sameEmail.valueChanges.subscribe((response) => {
        response
          ? this.profileForm.controls.notificationEmailID.setValue(
            this.profileForm.controls.adEmailID.value
          )
          : this.profileForm.controls.notificationEmailID.setValue(null);
      });
      this.profileForm.controls.secondLangFluencyCode.valueChanges.subscribe(
        (response) => {
          response
            ? this.profileForm.controls.secondLangCode.setValidators(
              Validators.required
            )
            : this.profileForm.controls.secondLangCode.setValidators(null);
          this.profileForm.controls.secondLangCode.updateValueAndValidity();
        }
      );
      this.profileForm.controls.isActive.valueChanges.subscribe((response) => {
        this.selectedStatus = response;
        this.showInactiveUserPopup = response === 'No' ? true : false;
        this.popupMessage = this.showInactiveUserPopup ? 'Are you sure you want to deactivate this user?' : '';
      });
      const user = this.profileForm.getRawValue();
      this.usersList = this.usersList && this.usersList.filter((item) => {
        return item.guid !== user.guid;
      });
      if (!this.selectedUser.updatedOn) {
        this.formEdit = false;
      }
    } catch (exp) {
      this.loggingService.logTrace('create-update-profile.component -> resetUserProfile' + exp);
    }
  }
  /**
   *
   *
   * @memberof CreateUpdateProfileComponent
   * @description used to close pop up
   */
  public closeUserStatusPopup(): void {
    this.showInactiveUserPopup = false;
    this.profileForm.controls.isActive.setValue('Yes');
  }
  /**
   *
   *
   * @memberof CreateUpdateProfileComponent
   */
  public onConfirm(): void {
    this.showInactiveUserPopup = false;
    // this.alert = {type: NOTIFICATION_SUCCESS, message: 'User deactivated successfully'};
  }
  /**
   *
   *
   * @memberof CreateUpdateProfileComponent
   * @description function calls when user click on cancel button 
   */
  public cancel(): void {
    try {
      if (this.profileForm.dirty) {
        this.showUnSavedChangesPopup = true;
        this.popupMessage = `${PROCEED_CHANGES}`;
      } else {
        this.router.navigateByUrl('/manage-users');
      }
    } catch (exp) {
      this.loggingService.logTrace('create-update-profile.component -> cancel' + exp);
    }
  }
  /**
   *
   *
   * @memberof CreateUpdateProfileComponent
   * @description used to close confirmation popup
   */
  public onCancellationConfirm(): void {
    this.showUnSavedChangesPopup = false;
    this.router.navigateByUrl('/manage-users');
  }
  /**
   *
   *
   * @memberof CreateUpdateProfileComponent
   * @description used to close unsaved popup
   */
  public closeUnsaveChangesPopup(): void {
    this.showUnSavedChangesPopup = false;
  }
  /**
   *
   *
   * @param {*} selected
   * @memberof CreateUpdateProfileComponent
   * @description function triggers when user select manager from list
   */
  public onReportingManagerSelected(selected): void {
    if (selected) {
      this.selectedReportingManager = selected.loginID;
    } else {
      this.selectedReportingManager = null;
    }
  }
  /**
   *
   *
   * @memberof CreateUpdateProfileComponent
   * @description used to get reporting manager login ID
   */
  public getReportingManagerLoginId(): void {
    try {
      if (this.usersList) {
        this.usersList.forEach((item) => {
          if (item.loginID === this.selectedUser.managerLoginID) {
            const name = `${item.firstName} ${item.lastName}`;
            this.profileForm.controls.managerLoginID.setValue(name);
          }
        });
      }
    } catch (exp) {
      this.loggingService.logTrace('create-update-profile.component -> getReportingManagerLoginId' + exp);
    }
  }
  /**
   *
   *
   * @memberof CreateUpdateProfileComponent
   * @description navigate to parent route
   */
  public onBackToWorkFlow(): void {
    if (this.router.url) {
      this.router.navigateByUrl(this.router.url.substr(1, this.router.url.indexOf('/user')).slice(0, -1));
    }
  }
}
